import $ from 'jquery';

var overflowTimeout;
$('.team__toggle').on('click', function () {
    var $contentWrap = $(this).closest('.team__content-wrap');
    $contentWrap.toggleClass('team__content-wrap--open');
    $contentWrap.find('.team__content').scrollTop(0);

    if($contentWrap.hasClass('team__content-wrap--open')) {
        $contentWrap.find('.team__scroll-arrow').addClass('team__scroll-arrow--show')
    } else {
        $contentWrap.find('.team__scroll-arrow').removeClass('team__scroll-arrow--show')
    }


    if($contentWrap.hasClass('team__content-wrap--open')) {
        overflowTimeout = setTimeout(function () {
            $contentWrap.addClass('team__content-wrap--overflow');
        },300)
    } else {
        clearTimeout(overflowTimeout);
        $contentWrap.removeClass('team__content-wrap--overflow');
    }
})

$('.team__content').on('scroll', function () {
    if($(this).parent().hasClass('team__content-wrap--open')) {
        if( this.scrollTop === (this.scrollHeight - this.offsetHeight)) {
            $(this).find('.team__scroll-arrow').removeClass('team__scroll-arrow--show')
        } else {
            $(this).find('.team__scroll-arrow').addClass('team__scroll-arrow--show')
        }
    }
})

$('.team__scroll-arrow').on('click', function () {
    $(this).parent().scrollTop(50000);
})